__turbopack_context__.v({
  "form": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__form",
  "infoBox": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__infoBox",
  "infoContent": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__infoContent",
  "infoIcon": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__infoIcon",
  "infoLink": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__infoLink",
  "infoText": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__infoText",
  "infoTitle": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__infoTitle",
  "panel": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__panel",
  "row": "EditTeamInvestorDetailsForm-module-scss-module__38N5lq__row",
});
